export const DATE_RANGES_COLORS = [
  'bg-sy-blue-50',
  'bg-sy-green-50',
  'bg-sy-red-50',
  'bg-sy-purple-50',
  'bg-sy-yellow-50',
] as const;
